"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8278],{

/***/ 433329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ BuildPcModalContent; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(912841);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(573194);
/* harmony import */ var _BuildPcItem_BuildPcItem_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(123579);
/* harmony import */ var _Common_NoProductsFound_NoProductsFound_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(980424);
/* harmony import */ var _Common_Loading_Loading_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(519209);







const StyledBuildPcItem = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_BuildPcItem_BuildPcItem_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BuildPcItem */ .y)`
  border-radius: unset;
  padding: 0.625rem 1rem;
  &:hover {
    box-shadow: unset;
  }
`;
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  height: ${(props) => props.height + "rem"};
  overflow-y: scroll;
  overflow-x: hidden;
  border-bottom: 1px dashed #ddd;
  border-top: 1px dashed #ddd;
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 8px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #999;
  }
`;
const StyledDivider = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .i)`
  width: 95%;
  margin: auto;
`;
const StyledNoProductsFound = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Common_NoProductsFound_NoProductsFound_es_js__WEBPACK_IMPORTED_MODULE_4__/* .NoProductsFound */ .H)`
  margin-top: 5rem;
`;
const BuildPcModalContent = ({
  products = [],
  isLoading,
  onClick
}) => {
  const windowSize = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .useWindowSize */ .i)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_Loading_Loading_es_js__WEBPACK_IMPORTED_MODULE_6__/* .Loading */ .g, {
    top: 150,
    isLoading: !!isLoading
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height: ((windowSize == null ? void 0 : windowSize.width) || 0) > 1600 ? 34.08 : 22.725
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledNoProductsFound, {
    show: !isLoading && !products.length
  }), products.map((product, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    key: product.sku
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBuildPcItem, {
    onClick: () => onClick(product.sku),
    key: product.sku,
    product,
    actionText: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("Ch\u1ECDn")
  }), index < products.length - 1 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDivider, null)))));
};




/***/ }),

/***/ 14956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BuildPcModalHeader; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(589561);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(918358);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(650983);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23212);
/* harmony import */ var _Common_JDDropdown_JDDropdown_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(786273);
/* harmony import */ var _Common_SelectOption_SelectOption_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(217622);
/* harmony import */ var _Listing_Filter_components_ActivatedFilters_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(743405);








const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  background: #fff;
`;
const Filter = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ isMobile }) => `
  ${isMobile ? `overflow-y: hidden;
      display: flex;
      gap: 5px;
      margin-bottom: 8px
      ` : `
    padding: 0 1rem 0.5rem 1rem;
      display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr 1fr 1fr;
  height: 84px;`}
`);
const StyledMiniDropdown = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Common_JDDropdown_JDDropdown_es_js__WEBPACK_IMPORTED_MODULE_2__/* .JDDropdown */ .F)`
  .dropdown-content {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  ${({ isMobile }) => isMobile ? `.dropdown-button {
    width: max-content;
  }` : ""}
`;
const Sort = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ isMobile }) => `
  ${isMobile ? "" : "padding: 0.5rem 1rem;"}
  display: flex;
  justify-content: space-between;
  align-items: center;
`);
const SortTitle = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  font-weight: 500;
  margin-right: 0.5rem;
`;
const StyledOption = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Common_SelectOption_SelectOption_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SelectOption */ .$)`
  padding: 0.365rem 0.75rem;
  cursor: pointer;
  color: ${(props) => props.isActive ? "#1435c3" : ""};
  &:hover {
    background: #f3f3f3;
  }
`;
const OptionName = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;
const Search = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .Input */ .I)(({ isMobile }) => `
  ${isMobile ? `` : `margin-left: 2rem;`}
  flex: 1;
  border-radius: ${isMobile ? "4px" : "999px"};
`);
const StyledTitle = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  font-size: 20px;
  font-weight: 600px;
  line-height: 24px;
  margin-bottom: 8px;
`;
const BuildPcModalHeader = ({
  filters = [],
  onClickFilter,
  onClickSort,
  activeValues = [],
  searchParams,
  isMobile = false
}) => {
  const onKeyUp = (e) => {
    const keyword = e.target.value;
    if (e.keyCode === 13) {
      onClickFilter && onClickFilter("keyword", keyword || "");
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, !isMobile ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .BlockHeader */ .t, {
    content: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Listing_Filter_components_ActivatedFilters_es_js__WEBPACK_IMPORTED_MODULE_6__/* .ActivatedFilters */ .x, {
      onClick: (value) => onClickFilter && onClickFilter(value.filterCode, value.optionCode),
      activeValues
    }),
    title: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("B\u1ED9 l\u1ECDc")
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTitle, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("B\u1ED9 l\u1ECDc")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Filter, {
    isMobile
  }, filters.map((filter, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledMiniDropdown, {
      count: activeValues.filter((value) => value.filterCode === filter.code).length,
      key: index,
      text: filter.name,
      isMobile
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, filter.options.map((value, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
      key: index2,
      link: true,
      variant: activeValues.findIndex((activatedValue) => activatedValue.optionCode === value.optionCode) !== -1 ? "primary" : "normal",
      onClick: () => onClickFilter && onClickFilter(filter.code, value.optionCode)
    }, value.optionName))));
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sort, {
    style: isMobile ? {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      gap: 8,
      marginBottom: "8px"
    } : void 0,
    isMobile
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SortTitle, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("S\u1EAFp x\u1EBFp theo")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      gap: isMobile ? 5 : 8
    }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledOption, {
    stickySize: "sm",
    isActive: searchParams && searchParams.sort === "quantity.last_3_month",
    activeBackground: "rgba(20, 53, 195, 0.08)",
    onClickOption: () => onClickSort && onClickSort("quantity.last_3_month", _types_es_js__WEBPACK_IMPORTED_MODULE_9__/* .OrderBy.DESC */ .d.DESC)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OptionName, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("B\xE1n ch\u1EA1y"))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledOption, {
    stickySize: "sm",
    isActive: searchParams && searchParams.sort === "bestPrice" && searchParams.order === _types_es_js__WEBPACK_IMPORTED_MODULE_9__/* .OrderBy.ASC */ .d.ASC,
    activeBackground: "rgba(20, 53, 195, 0.08)",
    onClickOption: () => onClickSort && onClickSort("bestPrice", _types_es_js__WEBPACK_IMPORTED_MODULE_9__/* .OrderBy.ASC */ .d.ASC)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OptionName, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("Gi\xE1 t\u0103ng d\u1EA7n"))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledOption, {
    stickySize: "sm",
    isActive: searchParams && searchParams.sort === "bestPrice" && searchParams.order === _types_es_js__WEBPACK_IMPORTED_MODULE_9__/* .OrderBy.DESC */ .d.DESC,
    activeBackground: "rgba(20, 53, 195, 0.08)",
    onClickOption: () => onClickSort && onClickSort("bestPrice", _types_es_js__WEBPACK_IMPORTED_MODULE_9__/* .OrderBy.DESC */ .d.DESC)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OptionName, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("Gi\xE1 gi\u1EA3m d\u1EA7n")))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Search, {
    onKeyUp,
    placeholder: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("T\xECm linh ki\u1EC7n"),
    isMobile
  })));
};




/***/ }),

/***/ 327601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ PrintBuildPc; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(526439);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(587021);
/* harmony import */ var _PrintBuildPcItem_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(523691);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: none;
  @media print {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    z-index: 99999;
    width: 100%;
    height: 100%;
  }
`;
const Header = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  padding: 1rem;
  text-align: center;
  background: #ebecee;
  width: 100%;
`;
const Logo = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div``;
const Content = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  padding: 1rem;
  width: 100%;
`;
const Footer = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  padding: 1rem;
  width: 100%;
  text-align: center;
`;
const Total = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  font-size: 1.5rem;
  color: #d10000;
  font-weight: 500;
`;
const PrintBuildPc = ({
  total,
  buildpc,
  logoProps
}) => {
  if (!Object.keys(buildpc).length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Header, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Logo, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, __spreadValues({
    src: "https://phongvu.vn/phongvu/logo-full.svg",
    height: 80,
    lazy: false
  }, logoProps)))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, null, Object.keys(buildpc).map((key) => {
    const product = buildpc[key].product;
    const quantity = buildpc[key].quantity;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_PrintBuildPcItem_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PrintBuildPcItem */ .p, {
      quantity,
      key,
      product
    });
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Footer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Total, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("T\u1ED5ng chi ph\xED:"), " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .Currency */ .F, {
    value: total
  }))));
};




/***/ }),

/***/ 523691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ PrintBuildPcItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(995667);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(865237);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(587021);
/* harmony import */ var _Common_ProductName_ProductName_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73586);
/* harmony import */ var _Common_ProductPrice_ProductPrice_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(770024);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const PrintBuildPcItem = ({
  product,
  quantity
}) => {
  var _a, _b, _c;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .Row */ .X, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
    col: 1.5
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
    width: 50,
    height: 50,
    src: product.imageUrl,
    objectFit: "contain",
    lazy: false
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
    col: 7.5
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_ProductName_ProductName_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductName */ .r, {
    name: product.name
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, null, "x", quantity), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
    col: 2
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_ProductPrice_ProductPrice_es_js__WEBPACK_IMPORTED_MODULE_5__/* .ProductPrice */ .j, __spreadValues({}, {
    price: ((_a = product == null ? void 0 : product.price) == null ? void 0 : _a.latestPrice) || 0,
    discount: ((_b = product == null ? void 0 : product.price) == null ? void 0 : _b.discountPercent) || "",
    listedPrice: ((_c = product == null ? void 0 : product.price) == null ? void 0 : _c.supplierRetailPrice) || 0
  }))));
};




/***/ }),

/***/ 786273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ JDDropdown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46610);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Button = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
  position: relative;
  padding: 0 1rem;
  text-align: center;
  height: ${props.height}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-sizing: content-box;
  border: 1px solid  var(--button-background-color, ${props.isOpen || props.count ? props.theme.brand.primary : props.theme.colors.gray300});
  color: ${props.count ? props.theme.brand.primary : ""};
  cursor: pointer;
  border-radius: 4px;
 
  ${props.isOpen && `
    z-index: 10;
    border-bottom: transparent;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `}
  `);
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: inline-block;
`;
const Text = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1;
  overflow: hidden;
`;
const StyledIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l)`
  position: relative;
  top: 1px;
  left: 2px;
`;
const DropdownContent = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: 1px solid ${props.theme.brand.primary};
  position: absolute;
  left: 0;
  right: 0;
  margin-top: -1px;
  z-index: 5;
  background: #fff;
`);
const Badge = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span(({ theme }) => `
    font-size: 0.625rem;
    background: ${theme == null ? void 0 : theme.brand.primary};
    border-radius: 50%;
    width: 16px;
    line-height: 16px;
    color: #fff;
    height: 16px;
    text-align: center;
    margin: 0 5px;
  `);
const JDDropdown = (_a) => {
  var _b = _a, {
    text,
    children,
    height = 34,
    count = 0
  } = _b, props = __objRest(_b, [
    "text",
    "children",
    "height",
    "count"
  ]);
  const [dropdownOpen, setDropdownOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [endDelay, setEndDelay] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (dropdownOpen) {
      setTimeout(() => {
        setEndDelay(true);
      }, 200);
    } else {
      setEndDelay(false);
    }
  }, [dropdownOpen, endDelay]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    onMouseEnter: () => setDropdownOpen(true),
    onMouseLeave: () => setDropdownOpen(false)
  }, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Button, {
    className: "dropdown-button",
    isOpen: dropdownOpen && endDelay,
    height,
    count
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, text), count > 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Badge, null, count), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: dropdownOpen && endDelay ? "chevron-up" : "chevron-down",
    size: 12
  })), dropdownOpen && endDelay && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownContent, {
    className: "dropdown-content",
    isOpen: dropdownOpen,
    height,
    onClick: () => setDropdownOpen(false)
  }, children));
};




/***/ }),

/***/ 519209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55257);
/* harmony import */ var _LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(465385);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledOverLay = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Overlay */ .a)`
  background: rgba(0, 0, 0, 0.03);
`;
const Loading = (_a) => {
  var _b = _a, {
    isLoading,
    children,
    logo
  } = _b, props = __objRest(_b, [
    "isLoading",
    "children",
    "logo"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledOverLay, __spreadProps(__spreadValues({}, props), {
    show: isLoading
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_3__/* .LogoLoading */ .h, {
    logo
  })), children);
};




/***/ }),

/***/ 804393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ MiniSlides; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(732553);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179185);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(428247);
/* harmony import */ var _PreLoad_PreLoad_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(301286);
/* harmony import */ var _CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(528938);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  border-radius: 0.5rem;
  overflow: hidden;
`;
const MiniSlides = (_a) => {
  var _b = _a, {
    banners = [],
    isLoading = false,
    regionName,
    height = 140,
    width = 1232
  } = _b, props = __objRest(_b, [
    "banners",
    "isLoading",
    "regionName",
    "height",
    "width"
  ]);
  if (isLoading)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_PreLoad_PreLoad_es_js__WEBPACK_IMPORTED_MODULE_2__/* .PreLoad */ .b, {
      height,
      isLoading
    });
  if (!isLoading && !banners.length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .t, {
    autoplay: {
      delay: 2500
    },
    slidesPerView: 1,
    loop: true,
    hasNavigation: true
  }, banners.map((banner, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __spreadValues({
      key: index,
      className: "swiper-slide"
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      isTrackContent: true,
      regionName: regionName || "topBanner",
      contentName: banner.campaignName,
      target: banner.targetPath,
      index
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x, {
      targetPath: banner.targetPath
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .LazyImage */ .w, {
      borderRadius: 8,
      height,
      src: banner.image,
      alt: banner.campaignName,
      width,
      imageWidth: width,
      hover: "zoom",
      cover: true
    })));
  })));
};




/***/ }),

/***/ 980424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ NoProductsFound; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(179185);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  margin-top: 8rem;
  text-align: center;
`;
const Text = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  margin-top: 1.5rem;
  font-size: 1rem;
`;
const NoProductsFound = (_a) => {
  var _b = _a, {
    text = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_2__.t)("Kh\xF4ng t\xECm th\u1EA5y s\u1EA3n ph\u1EA9m n\xE0o"),
    show
  } = _b, props = __objRest(_b, [
    "text",
    "show"
  ]);
  const NoProductImage = "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/no-products-found.png?alt=media&token=2f22ae28-6d48-49a7-a36b-e1a696618f9c";
  if (!show)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, {
    width: 200,
    height: 200,
    contain: true,
    src: NoProductImage
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, text));
};




/***/ }),

/***/ 301286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(465385);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: relative;
  border-radius: 0.5rem;
  background: #fff;
  height: ${(props) => props.height + "px"};
  user-select: none;
`;
const StyledLogoLoading = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__/* .LogoLoading */ .h)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;
const PreLoad = (_a) => {
  var _b = _a, {
    height,
    isLoading,
    hideLogo = false,
    logo
  } = _b, props = __objRest(_b, [
    "height",
    "isLoading",
    "hideLogo",
    "logo"
  ]);
  if (!isLoading)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    height
  }), !hideLogo && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLogoLoading, {
    logo
  }));
};




/***/ }),

/***/ 743405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ActivatedFilters; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46610);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(969061);



const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
const StyledIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l)(({ theme }) => `
    margin-left: 0.25rem;
    --button-icon-color: ${theme == null ? void 0 : theme.brand.primary};
  `);
const StyledChip = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Chip */ .A)(({ theme }) => `
  margin-right: 0.5rem;
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
  background: ${theme == null ? void 0 : theme.brand.tertiary} !important;
  color: ${theme == null ? void 0 : theme.brand.primary};
  border: 1px solid  ${theme == null ? void 0 : theme.brand.primary};
`);
const ActivatedFilters = ({
  activeValues,
  onClick
}) => {
  if (!activeValues.length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, activeValues.map((option) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledChip, {
    onClick: () => onClick && onClick(option),
    key: option.optionCode
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, option.optionName), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: "close",
    size: 10
  }))));
};




/***/ }),

/***/ 432283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ DetailNavBar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46610);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledDetailNavBar = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  height: 3.5rem;
  background: #fff;
  align-items: center;
  justify-content: space-between;
  &.detail {
    box-shadow: none;
  }
`;
const Left = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Right = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
`;
const DetailNavBar = (_a) => {
  var _b = _a, {
    right,
    goBack
  } = _b, props = __objRest(_b, [
    "right",
    "goBack"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDetailNavBar, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Left, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l, {
    name: "chevron-back",
    size: 24,
    onClick: goBack,
    color: "#333"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Right, null, right));
};




/***/ }),

/***/ 969061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 29px;
  height: 30px;
  border-radius: 999px;
  width: fit-content;
  text-align: center;
  background: #f6f6f6;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;
  outline: 0;
  white-space: nowrap;
  border: none;
  padding: 0 12px;
  cursor: pointer;
`;
const Chip = (_a) => {
  var _b = _a, {
    onClick,
    children
  } = _b, props = __objRest(_b, [
    "onClick",
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    onClick
  }), children);
};




/***/ }),

/***/ 918358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(428247);
/* harmony import */ var _atoms_Col_Col_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(865237);
/* harmony import */ var _atoms_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64201);
/* harmony import */ var _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(349055);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46610);








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  position: relative;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: ${props.hasDivider ? `1px solid ${props.color}` : ""};
`);
const Title = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  color: ${props.color};
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`);
const Decor = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  position: absolute;
  left: 0;
  margin-top: 2px;
  width: 3px;
  height: 21px;
  background-color:  ${props.color};
`);
const ActionLink = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  color: ${props.color} !important;
  --button-icon-color: ${props.color};
  text-decoration: none;
  float: right;
  text-decoration: unset;
  cursor: pointer;
  &:hover {
    ${props.hover === "underline" ? "text-decoration: underline" : `color: ${_configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.brand.primary */ .r.brand.primary} !important`}
  }
`);
const StyledIcon = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l)`
  position: relative;
  top: 2px;
`;
const ActionLinkTitle = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  margin-right: 5px;
`;
const BlockHeader = (_a) => {
  var _b = _a, {
    title,
    actionLink,
    color = "#333",
    hasDivider = false,
    content
  } = _b, props = __objRest(_b, [
    "title",
    "actionLink",
    "color",
    "hasDivider",
    "content"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    hasDivider,
    color
  }, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_Col_Col_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, null, title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Decor, {
    color
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, {
    color,
    className: "title"
  }, title))), content && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_Col_Col_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
    col: actionLink ? 9.8 : 10.95
  }, content), actionLink && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __spreadValues({}, actionLink.regionName && (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: actionLink.regionName,
    contentName: actionLink.contentName,
    target: actionLink.target
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_6__/* .CustomLink */ .x, {
    targetPath: actionLink.href
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionLink, {
    color: actionLink.color || "#f1f0f1",
    hover: actionLink.hover
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionLinkTitle, null, actionLink.title), !actionLink.hideIcon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: "chevron-forward",
    size: 13
  })))));
};




/***/ }),

/***/ 85468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(428247);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(650983);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46610);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";
const StyledPagination = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul */ .Z.ul`
  margin-top: 0;
  margin-bottom: 0;
  width: fit-content;
  display: flex;
`;
const StyledPaginationBtn = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li */ .Z.li(({ theme, disabled, active }) => `
    pointer-events: ${disabled ? "none" : "auto"};
    display: inline-block;
    ${active && `color: #fff;
      border-color: ${theme.brand.primary};
      &:hover {
        color: ${theme.brand.primary};
      }`}
  `);
const PageLink = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z)(({ theme, active }) => `
  min-width: 36px;
  height: 36px;
  text-align: center;
  box-shadow: none;
  border-color: #ced4da;
  color: ${theme.brand.primary};
  font-size: 12px;
  background-color: #fff;
  padding: 8px;
  margin: 5px;
  &:hover {
    background-color: #f4f4f4;
  }
  ${active && `color: #fff;
    background-color: ${theme.brand.primary};
    border-color: ${theme.brand.primary};
    border-radius: 4px;
    &:hover {
      color: ${theme.brand.primary};
      background-color: ${theme.brand.primary};
      color: #fff;
      border-color: ${theme.brand.primary};
    }
    `}
`);
const DotItem = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li */ .Z.li`
  pointer-events: none;
  display: flex;
  min-width: 36px;
  height: 36px;
  color: ${(props) => props.theme.brand.primary};
  padding: 8px;
  margin: 5px;
  font-size: 12px;
  justify-content: center;
`;
const PaginationButtonWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  z-index: 1;
  display: inline-block;
`;
const range = (from, to, step = 1) => {
  return Array.from(Array(to - from + 1).keys()).map((item) => item * step + from);
};
const Pagination = (_a) => {
  var _b = _a, {
    totalRecords = 0,
    pageLimit = 30,
    pageNeighbours = 2,
    onPageChanged,
    currentPage
  } = _b, props = __objRest(_b, [
    "totalRecords",
    "pageLimit",
    "pageNeighbours",
    "onPageChanged",
    "currentPage"
  ]);
  const totalPages = Math.ceil(totalRecords / pageLimit);
  const gotoPage = (page) => {
    onPageChanged(page);
  };
  const handleClick = (page, e) => {
    e.preventDefault();
    gotoPage(page);
  };
  const handleMoveLeft = (e) => {
    e.preventDefault();
    gotoPage(currentPage - 1);
  };
  const handleMoveRight = (e) => {
    e.preventDefault();
    gotoPage(currentPage + 1);
  };
  const fetchPageNumbers = () => {
    const totalNumbers = pageNeighbours * 2 + 3;
    const totalBlocks = totalNumbers + 2;
    if (totalPages > totalBlocks) {
      let pages2 = [];
      const curr = currentPage > totalPages ? totalPages : currentPage;
      const leftBound = curr - pageNeighbours;
      const rightBound = curr + pageNeighbours;
      const beforeLastPage = totalPages - 1;
      const startPage = leftBound > 2 ? leftBound : 2;
      const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;
      pages2 = range(startPage, endPage);
      const pagesCount = pages2.length;
      const singleSpillOffset = totalNumbers - pagesCount - 1;
      const leftSpill = startPage > 2;
      const rightSpill = endPage < beforeLastPage;
      const leftSpillPage = LEFT_PAGE;
      const rightSpillPage = RIGHT_PAGE;
      if (leftSpill && !rightSpill) {
        const extraPages = range(startPage - singleSpillOffset, startPage - 1);
        pages2 = [leftSpillPage, ...extraPages, ...pages2];
      } else if (!leftSpill && rightSpill) {
        const extraPages = range(endPage + 1, endPage + singleSpillOffset);
        pages2 = [...pages2, ...extraPages, rightSpillPage];
      } else if (leftSpill && rightSpill) {
        pages2 = [leftSpillPage, ...pages2, rightSpillPage];
      }
      return [1, ...pages2, totalPages];
    }
    return range(1, totalPages);
  };
  const pages = fetchPageNumbers();
  return pages.length > 0 ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("nav", __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPagination, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PaginationButtonWrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "paging",
    contentName: "previousPage"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPaginationBtn, {
    disabled: currentPage === 1
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageLink, {
    onClick: handleMoveLeft,
    "aria-label": "Previous page"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, {
    name: "chevron-back",
    size: 12
  })))), pages.map((page, index) => {
    if ([LEFT_PAGE, RIGHT_PAGE].includes(page)) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DotItem, {
        key: index
      }, "...");
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PaginationButtonWrapper, __spreadValues({
      key: index
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
      isTrackContent: true,
      regionName: "paging",
      contentName: "gotoPage",
      target: `${page}`
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPaginationBtn, {
      active: currentPage === page
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageLink, {
      onClick: (e) => handleClick(page, e),
      active: currentPage === page,
      "aria-label": "Next page"
    }, page)));
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PaginationButtonWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPaginationBtn, __spreadValues({
    disabled: currentPage === totalPages
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "paging",
    contentName: "nextPage"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageLink, {
    onClick: handleMoveRight
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, {
    name: "chevron-forward",
    size: 12
  })))))) : null;
};




/***/ }),

/***/ 732553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Swiper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(418668);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(649713);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(279215);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(909221);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(246626);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(172848);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ theme }) => `.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}
.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}
&:hover {
  .swiper-button-next,
  .swiper-button-prev {
    opacity: 1;
    &.swiper-button-disabled {
      opacity: 0.35;
    }
  }
}
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-top: -22px;
  background-color: rgba(168, 168, 168, 0.46);
  opacity: 0;
  &.swiper-button-disabled {
    opacity: 0;
    cursor: auto;
    pointer-events: auto;
  }
}
.swiper-pagination {
position: absolute;
text-align: center;
transform: translate3d(0, 0, 0);
z-index: 10;
}
.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #ddd;
}
.swiper-container-horizontal {
z-index: 0;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
  cursor: pointer;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}
.swiper-pagination-bullet-active {
  background: ${theme.brand.secondary};
  width: 24px;
  border-radius: 8px;
}
.swiper-button-next {
  right: 0;
  left: auto;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  &:after {
    mask: url("${_atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__/* .iconMap["chevron-forward"] */ .q["chevron-forward"]}");
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
}
.swiper-button-prev {
left: 0;
right: auto;
border-top-right-radius: 100px;
border-bottom-right-radius: 100px;
&:after {
  mask: url("${_atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__/* .iconMap["chevron-back"] */ .q["chevron-back"]}");
  content: ' ';
  height: 30px;
  width: 30px;
  mask-size: contain;
  display: inline-block;
  background: #333;
}
}`);
const Swiper = (_a) => {
  var _b = _a, {
    children,
    hasNavigation,
    hasPagination,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "hasNavigation",
    "hasPagination",
    "className"
  ]);
  const swiperProps = Object.assign({}, props);
  if (hasNavigation && !props.navigation) {
    swiperProps.navigation = true;
    swiper_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"].use */ .Z.use([swiper_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z]);
  }
  if (hasPagination && !props.pagination) {
    swiperProps.pagination = true;
    swiper_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"].use */ .Z.use([swiper_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z]);
  }
  const { slidesPerView = "auto" } = swiperProps;
  const renderContent = (e, index, slidesPerView2) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o, {
      style: {
        maxWidth: (slidesPerView2 === "auto" ? 100 : 100 / slidesPerView2) + "%"
      },
      key: index
    }, e);
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .Swiper */ .t, __spreadValues({}, swiperProps), react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, (e, index) => renderContent(e, index, slidesPerView))));
};




/***/ }),

/***/ 573194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72325);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46183);




function useWindowSize() {
  function getSize() {
    if (typeof window !== "undefined")
      return {
        width: window.innerWidth,
        height: window.innerHeight
      };
  }
  const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getSize);
  const updateWindowSize = lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(setWindowSize, 1e3);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .canUseDOM */ .Nq) {
      return;
    }
    function handleResize() {
      updateWindowSize(getSize());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  if (!_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .canUseDOM */ .Nq) {
    return void 0;
  }
  return windowSize;
}




/***/ })

}]);